import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  ReaImportResult,
  ReaMetricItem,
} from 'src/app/models/fincas/rea.model';

/**
 * Shows only the customer-facing result summary after a successful REA import.
 */
@Component({
  selector: 'app-rea-import-result-summary',
  templateUrl: './rea-import-result-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportResultSummaryComponent {
  @Input()
  public result: ReaImportResult | null = null;

  @Input()
  public customerSummaryMetrics: ReaMetricItem[] = [];

  public get visibleCustomerSummaryMetrics(): ReaMetricItem[] {
    return this.customerSummaryMetrics.filter((metric) => metric.visible);
  }
}

